var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExcel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4619 10.5535L5.85199 9.21289V19.1191C5.85208 19.2267 5.87337 19.3332 5.91463 19.4326C5.9559 19.532 6.01634 19.6223 6.0925 19.6984C6.16866 19.7744 6.25905 19.8347 6.35852 19.8758C6.45798 19.9169 6.56456 19.938 6.67218 19.9379H19.8034C19.9112 19.9382 20.0179 19.9172 20.1175 19.8762C20.2171 19.8351 20.3077 19.7749 20.384 19.6988C20.4603 19.6228 20.5209 19.5324 20.5622 19.433C20.6036 19.3335 20.6249 19.2268 20.625 19.1191V15.4691L13.4619 10.5535Z",
    fill: "#185C37"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4619 2.0625H6.67218C6.56456 2.06241 6.45798 2.08352 6.35852 2.12462C6.25905 2.16572 6.16866 2.22601 6.0925 2.30204C6.01634 2.37807 5.9559 2.46836 5.91463 2.56776C5.87337 2.66715 5.85208 2.77369 5.85199 2.88131V6.53125L13.4619 11L17.4914 12.3406L20.625 11V6.53125L13.4619 2.0625Z",
    fill: "#21A366"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.85199 6.53125H13.4619V11H5.85199V6.53125Z",
    fill: "#107C41"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M11.2984 5.63672H5.85199V16.8086H11.2984C11.5154 16.8075 11.7232 16.721 11.8769 16.5677C12.0305 16.4144 12.1176 16.2068 12.1192 15.9898V6.45553C12.1176 6.23851 12.0305 6.03088 11.8769 5.87761C11.7232 5.72435 11.5154 5.6378 11.2984 5.63672Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M10.8508 6.08398H5.85199V17.2559H10.8508C11.0678 17.2548 11.2757 17.1682 11.4293 17.015C11.583 16.8617 11.6701 16.6541 11.6717 16.437V6.9028C11.6701 6.68578 11.583 6.47814 11.4293 6.32488C11.2757 6.17161 11.0678 6.08506 10.8508 6.08398Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M10.8508 6.08398H5.85199V16.3621H10.8508C11.0678 16.361 11.2757 16.2745 11.4293 16.1212C11.583 15.968 11.6701 15.7603 11.6717 15.5433V6.9028C11.6701 6.68578 11.583 6.47814 11.4293 6.32488C11.2757 6.17161 11.0678 6.08506 10.8508 6.08398Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M10.4032 6.08398H5.85199V16.3621H10.4032C10.6203 16.361 10.8281 16.2745 10.9818 16.1212C11.1354 15.968 11.2225 15.7603 11.2241 15.5433V6.9028C11.2225 6.68578 11.1354 6.47814 10.9818 6.32488C10.8281 6.17161 10.6203 6.08506 10.4032 6.08398Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M2.19588 6.08399H10.4033C10.6207 6.0838 10.8292 6.16995 10.9832 6.32348C11.1371 6.47702 11.2238 6.68539 11.2241 6.9028V15.0964C11.2238 15.3138 11.1371 15.5222 10.9832 15.6757C10.8292 15.8293 10.6207 15.9154 10.4033 15.9152H2.19588C2.0882 15.9154 1.98154 15.8944 1.882 15.8533C1.78246 15.8123 1.69199 15.752 1.61576 15.6759C1.53952 15.5999 1.47902 15.5096 1.43771 15.4101C1.3964 15.3107 1.37509 15.2041 1.375 15.0964V6.9028C1.37509 6.79512 1.3964 6.68852 1.43771 6.58908C1.47902 6.48965 1.53952 6.39932 1.61576 6.32328C1.69199 6.24724 1.78246 6.18697 1.882 6.14591C1.98154 6.10485 2.0882 6.0838 2.19588 6.08399Z",
    fill: "url(#paint0_linear_2379_9438)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M3.91876 13.6633L5.64507 10.993L4.06382 8.33789H5.33364L6.19645 10.0381C6.2762 10.199 6.33395 10.3186 6.36007 10.3983H6.37176C6.42814 10.2691 6.48795 10.1446 6.55051 10.023L7.47314 8.34064H8.64189L7.02007 10.9806L8.68314 13.6653H7.43945L6.44257 11.8015C6.39629 11.7214 6.35696 11.6374 6.32501 11.5506H6.30851C6.27944 11.6352 6.24069 11.7162 6.19301 11.7919L5.16657 13.6633H3.91876Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8041 2.0625H13.4619V6.53125H20.625V2.88131C20.6249 2.77364 20.6036 2.66703 20.5623 2.5676C20.521 2.46816 20.4605 2.37784 20.3843 2.3018C20.308 2.22575 20.2175 2.16548 20.118 2.12442C20.0185 2.08336 19.9118 2.06232 19.8041 2.0625Z",
    fill: "#33C481"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4619 11H20.625V15.4688H13.4619V11Z",
    fill: "#107C41"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2379_9438",
    x1: 3.08963,
    y1: 5.44049,
    x2: 9.5095,
    y2: 16.5587,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#18884F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#117E43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B6631"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExcel);
export default __webpack_public_path__ + "static/media/Excel.800f37a9cb10659e51dcf0b0ad3da6e1.svg";
export { ForwardRef as ReactComponent };